import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

// Based on https://github.com/nkbt/react-height

/** @visibleName React Height */
export default class ReactHeight extends PureComponent {
  static propTypes = {
    dirty: PropTypes.bool,
    children: PropTypes.node.isRequired,
    onHeightReady: PropTypes.func.isRequired,
  };

  static defaultProps = {
    dirty: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      height: 0,
      dirty: this.props.dirty,
    };

    this.calcuateHeight = this.calcuateHeight.bind(this);
    this.toRef = this.toRef.bind(this);
  }

  componentDidMount() {
    this.calcuateHeight();

    window.addEventListener('load', this.calcuateHeight);
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.calcuateHeight);
    clearTimeout(this.timeout);
  }

  UNSAFE_componentWillReceiveProps({ dirty }) {
    if (dirty) {
      this.setState({
        dirty: true,
      });
    }
  }

  componentDidUpdate() {
    const height = (this.el && this.el.clientHeight) || 0;
    const dirty = false;

    if (height === this.state.height) {
      this.setState({ dirty });
    } else {
      this.setState({ height, dirty }, () =>
        this.props.onHeightReady(this.state.height)
      );
    }
  }

  calcuateHeight() {
    // setting a timeout 0 will wait for the next tick in order to avoid a race condition
    // (Safari issue - GMOBKTLO-13)
    this.timeout = setTimeout(() => {
      const height = (this.el && this.el.clientHeight) || 0;
      this.setState({ height }, () =>
        this.props.onHeightReady(this.state.height)
      );
    }, 0);
  }

  toRef(el) {
    this.el = el;
  }

  render() {
    return <div ref={this.toRef}>{this.props.children}</div>;
  }
}
